export default "__VITE_PUBLIC_ASSET__405b766b__"